import { Exception } from '../../../../core/logic/exception';

export class CreditNotFoundException extends Exception<never> {
  constructor() {
    super('Avoir non trouvé');
  }
}
